import { Controller } from "@hotwired/stimulus"

// Narrows the CSV import preview to one kind of row: new, already in the guide, problems or warnings
export default class extends Controller {
  static targets = ["row", "button", "empty"]

  show(event) {
    const filter = event.currentTarget.dataset.filter

    this.buttonTargets.forEach(button => button.setAttribute("aria-pressed", button.dataset.filter === filter))
    this.rowTargets.forEach(row => {
      const matches = filter === "all" || row.dataset.status === filter || (filter === "warned" && row.dataset.warned === "true")
      row.hidden = !matches
    })
    if (this.hasEmptyTarget) this.emptyTarget.hidden = this.rowTargets.some(row => !row.hidden)
  }
}
